import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

import { DivisionTargetComponent } from '../division-target/division-target.component';
import { PersonalTargetComponent } from '../personal-target/personal-target.component';

@Component({
  selector: 'app-input-goal',
  templateUrl: './input-goal.component.html',
  styleUrls: ['./input-goal.component.css']
})
export class InputGoalComponent implements OnInit {
  @ViewChild('d1') protected DivisionTarget: DivisionTargetComponent;
  @ViewChild('d2') protected DivisionTarget2: DivisionTargetComponent;
  @ViewChild('p') protected PersonalTarget: PersonalTargetComponent;

  years: number[] = [2019, 2018, 2017, 2016, 2015, 2014];
  months: any[] = [
    { month: 7, disabled: false },
    { month: 8, disabled: false },
    { month: 9, disabled: false },
    { month: 10, disabled: false },
    { month: 11, disabled: false },
    { month: 12, disabled: false },
    { month: 1, disabled: false },
    { month: 2, disabled: false },
    { month: 3, disabled: false },
    { month: 4, disabled: false },
    { month: 5, disabled: false },
    { month: 6, disabled: false },
  ];
  monthsYear: any = {}
  logininfo: Logininfo = this.authService.loginID;

  year: number;
  month: number;

  editContents: any = {
    all: false,
    division: false,
    personal: false,
  };

  message = [];
  error = [];

  constructor(
    public authService: AuthService,
  ) { }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    if (this.month < 7) {
      this.year--;
    }
    this.getType(this.logininfo.auth);
    this.setYears();
    this.ListHide();
  }

  //ログインユーザーの権限で表示項目選択
  getType(auth) {
    console.log('getType', auth);
    switch (auth.Auth) {
      case 'GENERAL':
        this.editContents = {
          all: true,
          division: true,
          personal: true,
        }
        break;
      case 'LEADER':
        this.editContents = {
          all: true,
          division: true,
          personal: true,
        }
        break;
      default:
        this.editContents = {
          all: false,
          division: false,
          personal: true,
        }
    }
    console.log('getType 2', this.editContents);
  }

  //未来のチェックボックスをクリック不可に
  ListHide() {
    /*
        this.months.forEach(item => {
          var y = this.year;
          if (item.month < 7) y++;
          let sel = new Date(y, item.month);
          let now = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
          if (now < sel) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
    */
   this.months = this.monthsYear[this.year].slice();
  }

  //子コンポーネントの保存処理実行
  save() {
    this.message = [];
    this.error = [];
    if (this.editContents.all) {
      this.DivisionTarget.save().subscribe((res: any) => {
        if (res.error == 1) {
          this.error.push('全体目標の保存に失敗しました');
        } else {
          this.message.push('全体目標を保存しました');
        }
      });
    }
    if (this.editContents.division) {
      this.DivisionTarget2.save().subscribe((res: any) => {
        if (res.error == 1) {
          this.error.push('事業部目標の保存に失敗しました');
        } else {
          this.message.push('事業部目標を保存しました');
        }
      });
    }
    if (this.editContents.personal) {
      this.PersonalTarget.save().subscribe((res: any) => {
        if (res.error == 1) {
          this.error.push('個人目標の保存に失敗しました');
        } else {
          this.message.push('個人目標を保存しました');
        }
      });
    }
  }

  setYears() {
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    if (month < 7) {
      year--;
    }
    
    // 今年度 +-1
    this.years = [year + 2, year + 1, year, year - 1]; // 年度
    this.years.forEach(y => {
      this.monthsYear[y] = this.months.slice();
      if (y > year) {
        let nextYear = new Date();
        nextYear.setFullYear(today.getFullYear() + 1);
        this.monthsYear[y].forEach(item => {
          let checkYear = y
          if (item.month < 7) checkYear++;
          let sel = new Date(checkYear, item.month - 1);
          if (nextYear < sel) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
      }
    });
  }
}
